// extracted by mini-css-extract-plugin
export default {"recos":"O7-z","productCardOverride":"P7-z","rowHasBadge":"Q7-z"};